import type { _ApiBlock } from './block'

export const sectionBlockKeys = [
  'section1',
  'section2',
  'section3',
  'section4',
  'section5',
] as const

type SectionBlockKey = (typeof sectionBlockKeys)[number]

export type CMSSectionsAPI = {
  id: string
  technicalName: string
} & Record<SectionBlockKey, _ApiBlock[]>
